export const indicatorWrapperStyles = {
	backgroundColor: '#fff',
	opacity: 0.5,
	zIndex: 3,
	left: 0,
	top: 0,
	display: 'flex',
	position: 'absolute',
	height: '100%',
	width: '100%',
	justifyContent: 'center',
	alignItems: 'center',
};
